import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF, MAIN_GROUP_ID } from '../../../Layout/tokens';
import { BLOTTER_PANELS, BLOTTERS_GROUP } from './shared';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  'historicalPriceChart_BTC-USD': {
    id: 'historicalPriceChart_BTC-USD',
    contentComponent: 'historicalPriceChart',
    title: 'BTC-USD',
    params: {
      symbol: 'BTC-USD',
      type: 'historicalPriceChart',
    },
  },
  'historicalPriceChart_ETH-USD': {
    id: 'historicalPriceChart_ETH-USD',
    contentComponent: 'historicalPriceChart',
    title: 'ETH-USD',
    params: {
      symbol: 'ETH-USD',
      type: 'historicalPriceChart',
    },
  },
  'historicalPriceChart_SOL-USD': {
    id: 'historicalPriceChart_SOL-USD',
    contentComponent: 'historicalPriceChart',
    title: 'SOL-USD',
    params: {
      symbol: 'SOL-USD',
      type: 'historicalPriceChart',
    },
  },
  'historicalPriceChart_BNB-USD': {
    id: 'historicalPriceChart_BNB-USD',
    contentComponent: 'historicalPriceChart',
    title: 'BNB-USD',
    params: {
      symbol: 'BNB-USD',
      type: 'historicalPriceChart',
    },
  },
  ...BLOTTER_PANELS,
};

const GRID = {
  root: {
    type: BRANCH,
    data: [
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: {
              views: ['historicalPriceChart_BTC-USD'],
              activeView: 'historicalPriceChart_BTC-USD',
              id: MAIN_GROUP_ID,
            },
            size: 100,
          },
          {
            type: LEAF,
            data: {
              views: ['historicalPriceChart_ETH-USD'],
              activeView: 'historicalPriceChart_ETH-USD',
              id: 'historicalPriceCharts-2',
            },
            size: 100,
          },
        ],
        size: 300,
      },
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: {
              views: ['historicalPriceChart_SOL-USD'],
              activeView: 'historicalPriceChart_SOL-USD',
              id: 'historicalPriceCharts-3',
            },
            size: 100,
          },
          {
            type: LEAF,
            data: {
              views: ['historicalPriceChart_BNB-USD'],
              activeView: 'historicalPriceChart_BNB-USD',
              id: 'historicalPriceCharts-4',
            },
            size: 100,
          },
        ],
        size: 300,
      },
      BLOTTERS_GROUP,
    ],
    size: 900,
  },
  width: 1000,
  height: 800,
  orientation: Orientation.VERTICAL,
};

export const CHART_VIEWS_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
